webpackJsonp([2],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Script to load Gotham & Font Awesome fonts for use in Coordinator App.
	 */
	
	// Font-Awesome fonts
	__webpack_require__(1196);
	
	// Gotham fonts
	__webpack_require__(1197);
	
	// Quadon fonts
	__webpack_require__(1198);

/***/ },

/***/ 1196:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 1197:
1196,

/***/ 1198:
1196

});


/** WEBPACK FOOTER **
 ** fonts-db460b75.js
 **/